import React, { useState, useEffect } from "react";
import { Container, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Swal from "sweetalert2";


function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'İmza İnternet Teknolojileri';

    if (localStorage.getItem('token')) {
      navigate("/home");
    }
  });

  const submitHandle = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/token`, { email: email, password: password })
          .then(function (response) {
            if (response.data.status === true) {
              localStorage.setItem("token", response.data.token);
              localStorage.setItem("userId", response.data.userId);
              localStorage.setItem("userRole", response.data.userRole);
              navigate("/home");
            }
            else {
              Swal.fire({
                text: response.data.message,
                icon: "error",
                confirmButtonText: "Tamam",
              });
            }

          });
    }
    catch (e) {
      console.log(e);
    }

  }

  return (
      <Container className="d-flex flex-column align-items-center vh-100">
        <Form onSubmit={submitHandle} method="POST" className="bg-white rounded border p-5 mw-400px w-100 m-auto">
          <h1 className="mb-4 fw-bolder text-primary">imza.</h1>
          <h2 className="fw-light mb-4">Hoşgeldiniz!</h2>


          <Form.Group className="mb-3">
            <Form.Label>E-Posta</Form.Label>
            <Form.Control type="text" name="email" onChange={e => setEmail(e.target.value)} required />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Şifre</Form.Label>
            <Form.Control type="password" name="password" onChange={e => setPassword(e.target.value)} required />
          </Form.Group>


          <Button disabled={!email || !password} variant="primary" type="submit" className="w-100">
            Giriş
          </Button>

        </Form>
      </Container>
  );
}

export default Login;
